import { Component, OnInit, inject } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NZ_MODAL_DATA } from "ng-zorro-antd/modal";

interface ModalData {
  documentUrl: string;
  documentName: string;
  extension: string;
}

@Component({
    selector: "app-document-viewer-modal",
    templateUrl: "./document-viewer-modal.component.html",
    styleUrls: ["./document-viewer-modal.component.less"],
    standalone: false
})
export class DocumentViewerModalComponent implements OnInit {
  readonly nzModalData: ModalData = inject(NZ_MODAL_DATA);
  
  safeDocumentUrl: SafeResourceUrl;
  isLoading: boolean = true;
  loadError: boolean = false;

  constructor(private sanitizer: DomSanitizer) {}

  ngOnInit() {
    console.log("Document viewer modal opened with data:", this.nzModalData);
    this.safeDocumentUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.nzModalData.documentUrl
    );
  }

  onIframeLoad() {
    this.isLoading = false;
    console.log("Document loaded successfully");
  }

  onIframeError() {
    this.isLoading = false;
    this.loadError = true;
    console.error("Failed to load document");
  }

  get isPdf(): boolean {
    return this.nzModalData.extension.toLowerCase() === 'pdf';
  }

  get isMarkdown(): boolean {
    return this.nzModalData.extension.toLowerCase() === 'md';
  }

  openInNewTab() {
    window.open(this.nzModalData.documentUrl, '_blank');
  }
}

